<template>
    <div class="goods_line_bottom">
        <div class="tabs_content">
            <ul>
                <li class="active">最近购买的商品</li>
                <li @click="orderjump(2)">收藏的商品</li>
                <li @click="orderjump(3)">看过的商品</li>
            </ul>
        </div>
        <GoodsList :type="type"></GoodsList>
    </div>
</template>

<script>
import GoodsList from '@/components/views/promotion/goodslist.vue'
export default {
    components: {GoodsList},
    data() {
        return {
            type: 1, // 0 商品促销 1 最近购买的商品
        }
    },
    methods: {
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Replenish'
            } else if (sign == 2) {
                link = '/Collection'
            } else {
                link = '/Seen'
            }
            this.$router.push(link)
        },
        
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/goods/replenish.vue